<swiper [slidesPerGroup]="postSuggestionsSliderOptions.slidesPerGroup" [pagination]="true" [slidesPerView]="postSuggestionsSliderOptions.slidesPerView" (swiper)="setSwiperInstance($event)" *ngIf="view.posts && view.posts.length">
  <div *ngFor="let post of view.posts" [hidden]="!!post.hidden">
    <ng-template swiperSlide>
      <pipeline-post-card [post]="post" [options]="postCardOptions" *ngIf="!post.hidden"></pipeline-post-card>
    </ng-template> 
  </div>
</swiper>